import {
  ModalBottomSheet,
  Section,
  TextParagraph,
} from '@ferreri/prever-component-lib';
import { CategoriesListWrapContainer } from './CategoriesListWrapContainer';
import { useCategoriesListByPublicationCategory } from '../../../categories/categories.store';
import { CategoriesListItem } from './CategoriesListItem';

type Props = {
  isOpen: boolean;
  onClose?: () => void;
  onCloseClick?: () => void;
};

export const CategoriesListModal = ({
  isOpen,
  onClose,
  onCloseClick,
}: Props) => {
  const { data: categoriesList, isLoading } =
    useCategoriesListByPublicationCategory();

  return (
    <ModalBottomSheet
      title="Categorias"
      renderModalOnPortal
      hasCloseButton
      isOpen={isOpen}
      onClose={onClose}
      onCloseClick={onCloseClick}
      isLoadingButtonPrimary={isLoading}
    >
      <Section>
        <TextParagraph>
          Escolha uma das categorias para ver todos os benefícios relacionados a
          ele.
        </TextParagraph>
        <CategoriesListWrapContainer>
          {categoriesList?.map((category) => (
            <CategoriesListItem key={category?.id} category={category} />
          ))}
        </CategoriesListWrapContainer>
      </Section>
    </ModalBottomSheet>
  );
};
